<template>
  <el-card>
    <template #header>
      <h4>{{ title }}</h4>
    </template>

    <div class="mb16" style="display: flex;align-items: center;justify-content: space-between">
      <div class="count-item">
        <div class="item-icon">
          <img src="@/assets/icon1.png" class="icon"/>
        </div>
        <div class="item-right">
          <span>{{ $t('当日使用次数') }}</span>
          <span class="count">{{ orderInfo.todayUseCount || 0 }}</span>
        </div>
      </div>

      <div class="count-item">
        <div class="item-icon">
          <img src="@/assets/icon2.png" class="icon"/>
        </div>
        <div class="item-right">
          <span>{{ $t('使用总次数') }}</span>
          <span class="count">{{ orderInfo.totalUseCount || 0 }}</span>
        </div>
      </div>

      <div class="count-item">
        <div class="item-icon">
          <img src="@/assets/icon3.png" class="icon"/>
        </div>
        <div class="item-right">
          <span>{{ $t('当日使用人数') }}</span>
          <span class="count">{{ orderInfo.todayUsePerson || 0 }}</span>
        </div>
      </div>

      <div class="count-item">
        <div class="item-icon">
          <img src="@/assets/icon4.png" class="icon"/>
        </div>
        <div class="item-right">
          <span>{{ $t('总使用人数') }}</span>
          <span class="count">{{ orderInfo.totalUsePerson || 0 }}</span>
        </div>
      </div>
    </div>

    <table-list
        :show-page="false"
        :on-page="false"
        ref="list"
        @query="loadList"
        :search-params="searchParams"
        @selection-change="selection = $event"
        :data="listData"
        :auto="true">

      <el-table-column type="selection" width="90px"/>

      <template v-for="(column, index) in columnConfig">
        <el-table-column :label="$t(column.label)" :prop="column.prop" :key="index"/>
      </template>

    </table-list>

  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";

export default {
  name: "DeviceCardTable",
  components: {TableList},
  props: {
    title: {
      type: String,
      default: "标题"
    },
   /* columnConfig: {
      type: Array,
      default: () => {
        return [
          {prop: 'name', label: '名称'}
        ]
      }
    },*/
    action: {
      type: String,
      default: ""
    },
    currentName: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    searchParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      listData: [],
      orderInfo: {},
      selection: [],
      tableRef: {},
      columnConfig: [
        {label: "品牌", prop: "brand"},
        {label: "使用型号", prop: "model"},
        {label: "规格", prop: "spec"},
        {label: "当日使用次数", prop: "todayUseCount"},
        {label: "使用总次数", prop: "totalUseCount"},
        {label: "当日使用人数", prop: "todayUsePerson"},
        {label: "总使用人数", prop: "totalUsePerson"},
      ],
    }
  },
  activated() {
    console.log("进入")
  },
  mounted() {
    const tableRef = this.$refs.list.getDom();
    this.tableRef = tableRef
  },
  methods: {
    async loadList(params) {
      try {
        const res = await request(this.action, params);
        for (const key in res) {
          if (Array.isArray(res[key])) {
            this.listData = res[key];
            break;
          }
        }
        this.orderInfo = res;
        this.listData.forEach(item => {
          this.selection.forEach(selection => {
            if (JSON.stringify(item) === JSON.stringify(selection)) {
              this.$nextTick(() => {
                this.tableRef.toggleRowSelection(item, true);
              })
            }
          })
        })
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    currentName: {
      handler(currentName) {
        if (currentName === this.name) {
          this.$nextTick(() => {
            // this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    },
    searchParams: {
      handler() {
        if (this.currentName === this.name) {
          this.$nextTick(() => {
            this.$refs.list.handleSearch();
          })
        }
      },
      deep: true,
    },
    selection: {
      handler(list) {
        const codes = list.map(i => i.deviceId);
        this.$emit("select", codes);
      },
      immediate: true,
    }

  },

}
</script>

<style scoped>

.count-item {
  display: flex;
  height: 100px;
  align-items: center;
}

.item-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 6px;
  background: #62abff;
  border-radius: 6px;
  margin-right: 18px;
}

.icon {
  width: 50px;
  height: 50px;
}

.item-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.count {
  font-weight: 600;
  font-size: 22px;
  line-height: 34px;
}

</style>
